import { createSceneReducer } from 'reducers/reducers-util';
import projectOpenItemsDataReducer from 'components/admin/project-open-items/store/reducers.data';

export default createSceneReducer(projectOpenItemsDataReducer);
